export default "/assets/images/overreactor-hero-image.png?0a451ba5c8285024c8e7dcc2e1d4ae60";